import { useEffect, useState, type ReactNode } from 'react';
import { GuestContext } from '../guestMode';
import { fetchHomeStats, type HomeStats } from '../api/preview';

/** Supplies the signed-out preview's flag and the public copy of the Home
 *  rails' stats. See guestMode.ts for why the data rides a context. */
export default function GuestProvider({ guest, children }: { guest: boolean; children: ReactNode }) {
  const [stats, setStats] = useState<HomeStats | null>(null);

  useEffect(() => {
    if (!guest) return;
    let cancelled = false;
    fetchHomeStats()
      .then((s) => { if (!cancelled) setStats(s); })
      // A rail that can't load renders empty, the way it does offline. Settled
      // with every key null rather than left at null: the rails read this
      // context to tell "not here yet" (skeleton) from "nothing to show".
      .catch(() => {
        if (!cancelled) setStats({ promotions: null, mostStarred: null, upcomingEvents: null, rules: null });
      });
    return () => { cancelled = true; };
  }, [guest]);

  return <GuestContext.Provider value={{ guest, stats }}>{children}</GuestContext.Provider>;
}
